import { Component, Input, OnInit } from '@angular/core';
import { AccessLevel } from 'app/core/user/user.model';
import { UserService } from 'app/core/user/user.service';

@Component({
  selector: 'app-user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.scss'],
})
export class UserPermissionComponent implements OnInit {
  @Input() permissionId: AccessLevel;

  enabled = false;

  constructor(private userService: UserService) {}

  async ngOnInit() {
    const currentUser = await this.userService.getCurrentUser();
    if (currentUser.permissions.includes(this.permissionId)) {
      this.enabled = true;
    }
  }
}
